// Web-only stand-in for "expo-screen-capture" (iOS/Android only).
// Browsers give a page no control over screenshots, so every entry point is a
// no-op instead of throwing UnavailabilityError from inside a useEffect.

export const usePreventScreenCapture = (_key?: string): void => {};

export const preventScreenCaptureAsync = async (_key?: string): Promise<void> => {};

export const allowScreenCaptureAsync = async (_key?: string): Promise<void> => {};

export const isAvailableAsync = async (): Promise<boolean> => false;

export const addScreenshotListener = (_listener: () => void) => ({
	remove: () => {},
});

export const removeScreenshotListener = (_subscription: { remove: () => void }) => {};
